import React from "react";
import MdAttachment from "react-icons/lib/md/attachment";
import "./AttachmentCounter.css";

const AttachmentCounter = ({ onClick, attachments, type }) => {
	return attachments[type] ? (
		<button
			className="btn-plain attachment-counter"
			onClick={onClick.bind(null, type)}
		>
			<MdAttachment size={18} />
			<span>{attachments[type]}</span>
		</button>
	) : null;
};

export default AttachmentCounter;



// WEBPACK FOOTER //
// ./src/components/main/projects/_common/AttachmentCounter.js